import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const schema = () => {
  const { t } = useTranslation('');
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return yup.object().shape({
    // creditCardNumber: yup
    //   .string()
    //   .matches(/^[0-9]+$/, t('common_field_label_required'))
    //   .min(15, t('common_field_label_required')),
    nameOnCard: yup
      .string()
      .required(t('common_field_label_required'))
      .min(3, t('common_field_label_required')),
    // date: yup
    //   .date()
    //   .min(today, t('common_field_label_required')),
  });
};
